<script>
    import Moon from 'svelte-loading-spinners/dist/ts/Moon.svelte';

    export let title = '';
    export let data;
    export let type;
    export let suffix = '';
    export let prefix = '';
    export let loading = false;

    if (type == 'percent' && !!data) data.count = (data.count * 100).toFixed(2);
</script>

<div class="figure-widget p-4 transition-shadow border rounded-lg shadow-sm hover:shadow-lg  bg-white figure-widget">
    {#if loading}
        <div class="h-16 flex items-center justify-center">
            <Moon size={2} color="#FF3E00" unit="rem" duration="1s" />
        </div>
    {:else}
    <div class="flex items-start justify-between">
        <div class="flex flex-col space-y-2">
            <span class="text-gray-700">{title}</span>
            <span class="text-lg font-semibold" >{prefix}{data.count.toLocaleString()}{suffix}</span>
        </div>
        <div class="p-10 bg-gray-200 rounded-md" />
    </div>
    <div>
        <span class="inline-block px-2 text-sm text-white bg-green-300 rounded {data.delta<0 && 'hidden'}">
            {data.delta.toFixed(2)}%
        </span>
        <span>From last 24/h</span>
    </div>
  {/if}
</div>
<style>
    .figure-widget{
        min-height: 138px;
    }
</style>
